import { render } from "./HomePage.vue?vue&type=template&id=2170167a"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=2170167a&lang=css"
script.render = render

export default script